<div class="container">
  <h2 class="mb-4">Members List</h2>

  <!-- Dropdown to select a client -->
  <div class="mb-3">
    <!-- <label for="clientSelect" class="form-label" style="text-align: left; width: 100vw;">Select Client</label> -->
    <select id="clientSelect" class="form-select" [(ngModel)]="selectedClientId" (change)="filterMembers()">
      <option value="" selected>All Clients</option>
      <option *ngFor="let client of clientsData" [value]="client.id">{{ client.companyName }}</option>
    </select>
  </div>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Client</th>
        <th>Member Name</th>
        <th>Email</th>
        <th>Mobile</th>
        <th>Skype ID</th>
        <th>Telephone</th>
        <th>Is WhatsApp</th>
        <th>Actions</th> <!-- Actions column -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let member of filteredMembersData">
        <td>{{ getClientName(member.clientId) }}</td> <!-- Display client name based on clientId -->
        <td>{{ member.memberName }}</td>
        <td>{{ member.email }}</td>
        <td>{{ member.mobile }}</td>
        <td>{{ member.skypeId || '-' }}</td>
        <td>{{ member.telephone || '-' }}</td>
        <td>
          <span *ngIf="member.isWhatsApp" class="text-success">✔️</span>
          <span *ngIf="!member.isWhatsApp" class="text-danger">❌</span>
        </td>
        <td>
          <button class="btn btn-secondary btn-sm" (click)="updateMember(member)"
            [disabled]="!hasPermission('MembersAddNewMemberPermission')">Update</button>
          <button class="btn btn-danger btn-sm" (click)="deleteMember(member)">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
